import React from 'react';
import { FormattedMessage } from '../Intl';
import { Experiment } from '../Experiment';
import cnames from 'classnames';

import './HeadLine.less';

const CNAME = 'HeadLine';

const HeadLine = () => (
  <Experiment name={'HA_PTA_HP_StayzOnPlatform'}>
    {value => (
      <h1 className={cnames(CNAME, { [`${CNAME}--overlapping-value-props`]: value === 0 })}>
        <FormattedMessage id="homepage.heading" defaultMessage={'Book beach houses, cabins,# condos and more, worldwide'}>
          {title => title.split('#').map((text, index) => <span key={index} className={`${CNAME}__text`}>{text.trim()}</span>)}
        </FormattedMessage>
      </h1>
    )}
  </Experiment>
);

export default HeadLine;
